<template>
    <transition name="fade">
        <div
v-if="show" :class="`d-flex align-items-center position-fixed bottom-0 end-0 m-4`" role="alert"
            style="z-index: 1050;">
            <argon-alert :color="type" :icon="icon" dismissible>
                <strong>{{ title }}!</strong> {{ message }}
            </argon-alert>
        </div>
    </transition>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import ArgonAlert from "@/components/ArgonAlert.vue";

// Reactive state
const show = ref(false)
const title = ref('')
const message = ref('')
const type = ref('success')
const icon = ref('')

// Function to show notification
const showNotification = ({ messageTitle, messageText, typeText = 'success', iconText = '' }) => {
    title.value = messageTitle
    message.value = messageText
    type.value = typeText
    icon.value = iconText
    show.value = true

    setTimeout(() => {
        hideNotification()
    }, 3000)
}

// Function to hide notification
const hideNotification = () => {
    show.value = false
}

// Setup lifecycle hooks to listen for events
onMounted(() => {
    window.addEventListener('show-notification', (event) => showNotification(event.detail))
})

onBeforeUnmount(() => {
    window.removeEventListener('show-notification', showNotification)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
